import { render, staticRenderFns } from "./order_settle_type.vue?vue&type=template&id=59079836&"
import script from "./order_settle_type.vue?vue&type=script&lang=ts&"
export * from "./order_settle_type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports